export default __webpack_public_path__ + "static/media/buy.f84d0ce2.png";